import React, { useEffect, useState, useRef } from "react";
import Footerdeo from "../shared/Footerdeo";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import $ from "jquery";

function Totalschools() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true); // 👈 loading state

  useEffect(() => {
    const fetchSchoolList = async () => {
      try {
        const response = await axios.post(
          `${config.API_BASE_URL}/FetchDEOTotalListOfSchools_CL9`,
          { deO_ID: sessionStorage.getItem("deoId") },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && response.data.status === 200) {
          setSchools(response.data.data.deoTotalSchools_list || []);
        } else {
          console.error("Failed to fetch schools:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSchoolList();
  }, []);
  useEffect(() => {
    if (schools.length > 0) {
      const table = $(tableRef.current).DataTable({
        paging: true,
        searching: true,
        info: true,
        pageLength: 100,
        ordering: false,
        responsive: true,
        destroy: true,
        columnDefs: [{ orderable: false, targets: 0 }],
      });

      return () => table.destroy();
    }
  }, [schools]);
  return (
    <>
      <div className="container-scroller">
        <Navbardeo />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper">
          <Sidebardeo />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row align-items-center justify-content-between">
                    <div className="col-12 col-md-6">
                      <h3 className="font-weight-bold">
                        Total List of Schools
                      </h3>
                    </div>
                    <div className="col-12 col-md-6 text-md-end">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-md-end mb-0 text-secondary">
                          <li className="breadcrumb-item">
                            <a
                              href="/deo-dashboard"
                              className="text-secondary text-decoration-none"
                            >
                              <i className="fa fa-tachometer me-1"></i>
                              Home
                            </a>
                          </li>
                          <li
                            className="breadcrumb-item active text-secondary"
                            aria-current="page"
                          >
                            Total Schools
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <table
                        ref={tableRef}
                        className="table table-condensed table-striped table-bordered"
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>Sl No.</th>
                            <th style={{ textAlign: "left" }}>School Code</th>
                            <th style={{ textAlign: "left" }}>School Name</th>
                            <th style={{ textAlign: "left" }}>Pin code</th>
                            <th style={{ textAlign: "left" }}>Post Office</th>
                            <th style={{ textAlign: "left" }}>
                              No. Of Candidate
                            </th>
                            <th style={{ textAlign: "left" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {schools.length > 0 ? (
                            schools.map((school, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{school.schooL_CODE}</td>
                                <td>{school.schooL_NAME}</td>
                                <td>{school.piN_CODE}</td>
                                <td>{school.posT_OFFICE || "N/A"}</td>
                                <td>{school.nO_OF_STUDENT}</td>
                                <td>
                                  <button
                                    className="btn bg-success text-white"
                                    onClick={() =>
                                      navigate("/total-applicant", {
                                        state: {
                                          schoolCode: school.schooL_CODE,
                                        },
                                      })
                                    }
                                  >
                                    Check Details{" "}
                                    <i className="fa-solid fa-angles-right"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-3">
                                No school data found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footerdeo />
          </div>
        </div>
      </div>
    </>
  );
}

export default Totalschools;
